<template>
  <form @submit.prevent="submit">
    <div class="columns is-multiline">
      <name-field
        :name.sync="fields.name.value"
        class="column is-full-mobile"
        @error="fields.name.error = $event"
      />
      <category-field
        class="column is-full-mobile"
        :live-categories="liveCategories"
        :live-category-ids.sync="fields.liveCategoryIds.value"
      />
    </div>
    <div class="columns is-multiline">
      <tracker-interval-field
        label="Événement d'entrée*"
        message="Modifie l'intervalle des trackers entrant dans la zone"
        :tracker-interval.sync="fields.inTrackerInterval.value"
        :error-message="inTrackerIntervalErrorMessage"
        class="column is-full-mobile"
        @error="fields.inTrackerInterval.error = $event"
      />
    </div>
    <div class="columns is-multiline">
      <location-field
        class="column"
        :coordinate-format="coordinateFormat"
        :location.sync="fields.location.value"
        @error="fields.location.error = $event"
        @update:location="$emit('update:geofence', { ...geofence, location: $event })"
      />
      <radius-field
        class="column is-full-mobile"
        :radius.sync="fields.radius.value"
        @error="fields.radius.error = $event"
        @update:radius="$emit('update:geofence', { ...geofence, radius: $event })"
      />
    </div>
    <b-field class="buttons">
      <b-button
        :disabled="loading || error"
        :loading="loading"
        label="Modifier"
        native-type="submit"
        type="is-primary"
      />
      <b-button type="is-danger" label="Annuler" @click="$emit('cancel')" />
    </b-field>
  </form>
</template>

<script>
import LocationField from './FormField/LocationField.vue'
import CategoryField from './FormField/CategoryField.vue'
import NameField from './FormField/NameField.vue'
import RadiusField from './FormField/RadiusField.vue'
import TrackerIntervalField from './FormField/TrackerIntervalField.vue'
import { mapActions } from 'vuex'

export default {
  name: 'EditForm',

  components: {
    CategoryField,
    LocationField,
    NameField,
    RadiusField,
    TrackerIntervalField,
  },

  props: {
    geofence: {
      type: Object,
      required: true,
    },
    coordinateFormat: {
      type: String,
      required: true,
    },
    liveCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      fields: {
        location: {
          value: this.geofence.location,
          error: false,
        },
        radius: {
          value: this.geofence.radius,
          error: false,
        },
        inTrackerInterval: {
          value: this.geofence.inTrackerInterval,
          error: false,
        },
        name: {
          value: this.geofence.name,
          error: false,
        },
        liveCategoryIds: {
          value: this.geofence.liveCategoryIds,
        },
      },
    }
  },

  watch: {
    geofence: {
      handler(geofence) {
        this.fields.location.value = geofence.location
        this.fields.radius.value = geofence.radius
      },
      deep: true,
    },
  },

  computed: {
    inTrackerIntervalErrorMessage() {
      return !this.fields.inTrackerInterval.value ? "l'événement est requis" : null
    },

    error() {
      return Object.values(this.fields).find((field) => field.error === true)
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit() {
      this.loading = true

      try {
        const liveStageGeofence = await this.$services.liveTrackerGeofenceService.update({
          ...this.geofence,
          location: {
            latitude: this.fields.location.value[0],
            longitude: this.fields.location.value[1],
          },
          radius: this.fields.radius.value,
          inTrackerInterval: this.fields.inTrackerInterval.value,
          name: this.fields.name.value,
          liveCategoryIds: this.fields.liveCategoryIds.value,
        })

        this.$emit('update', liveStageGeofence)

        this.addToastMessage({
          text: `Le geofence "${liveStageGeofence.name}" a été modifié.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? `La modification du geofence ${this.geofence.name} a échouée.`,
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },
  },
}
</script>
